<section class="consejo-directivo mb-5">
  <div class="row m-0 header justify-content-center">
    <h1 class="title">Estatutos</h1>
  </div>
  <div class="row mt-3 mt-md-5 mx-3 mx-md-0">
    <div class="col-md-2 col-0"></div>
    <div class="col-12 col-md-8 justify-content-center">
      <div class="row">
        <div class="col d-flex align-items-end flex-column">
          <form class="form-inline my-2 my-lg-0" id="search">
            <mat-form-field class="search-bar">
              <mat-label>Realizar una búsqueda...</mat-label>
              <input
                matInput
                type="text"
                name="busqueda"
                [(ngModel)]="value"
                placeholder="Realiza una búsqueda"
                (keyup.enter)="onEnter()"
                (keydown.esc)="onEscEvent()"
                (keyup)="onSearchKey($event)"
              />
              <!-- <button
                mat-button
                *ngIf="value"
                matSuffix
                mat-icon-button
                aria-label="Clear"
                (click)="onEscEvent()"
              >
                <mat-icon>close</mat-icon>
              </button> -->
            </mat-form-field>
          </form>
        </div>
      </div>
      <!-- Contenido starts -->

      <div class="row">
        <div
          class="col summary"
          [markjsHighlight]="value"
          [markjsConfig]="searchConfig"
          [scrollToFirstMarked]="true"
        >
          <h1>Título I Disposiciones generales</h1>
          <h2>
            Capítulo 1. De la constitución, denominación, duración, domicilio y
            patrimonio.
          </h2>
          <p>
            <strong>Artículo primero.- </strong>
            La denominación será. Colegio de Arquitectos Tabasqueños Asociación
            Civil. O de su abreviatura A.C., siendo una institución autónoma,
            con personalidad jurídica y patrimonio propio, insertado en la
            escritura 1374 con fecha 17 de Octubre de 1974, volumen y folio XXII
            (veintidós), acto jurídico que contiene la constitución de una
            asociación civil denominada “Colegio de Arquitectos Residentes en el
            Estado de Tabasco”, ante el notario público sustituto Lic. Armando
            Mayo Sánchez, en la notaría pública No. 12 (doce), de la que es
            titular el Lic. Antonio Ocampo Ramírez, quedando inscrito en el
            registro público de la propiedad y del comercio bajo el número mil
            quinientos treinta y tres, del libro general de entradas a folios
            del doscientos cincuenta y nueve al doscientos noventa y tres, del
            libro de sociedades civiles.
          </p>
          <p>
            En asamblea ordinaria con fecha veintiséis de Febrero de mil
            novecientos noventa, se propone cambio de la denominación “Colegio
            de Arquitectos Residentes en el estado de Tabasco”, por “Colegio de
            Arquitectos Tabasqueños”, autorizado por la secretaría de relaciones
            exteriores, mediante permiso número 020726 (veinte mil setecientos
            veintiséis), expediente no. 505820 (quinientos cinco mil ochocientos
            veinte), de fecha veintiocho de Marzo de mil novecientos noventa,
            con la protocolización ante notario Lic. Roque Camelo Verduzco,
            notario No. 11 (once), contenido en la escritura pública, fue
            inscrito bajo folio 4429 del libro general de entradas; a folios del
            206 al 204 bis del libro No. cuatro de sociedades civiles, volumen
            15.- rec. No. 330148.
          </p>
          <p>
            <strong>Artículo segundo.- </strong>
            El Colegio de Arquitectos Tabasqueños A.C., tendrá una duración de
            99 años, y tendrá jurisdicción dentro del estado de Tabasco.
          </p>
          <p>
            <strong>Artículo tercero.- </strong>
            Del domicilio social del Colegio de Arquitectos Tabasqueños A.C.
            será ciudad de Villahermosa capital del Estado de Tabasco.
          </p>
          <p>
            <strong>Artículo cuarto.- </strong>
            El patrimonio del Colegio de Arquitecto Tabasqueños A.C. se formará
            por:
          </p>
          <p>
            <strong>a) </strong>
            Las cuotas que anualmente deberán cubrir los miembros, mismas que
            serán determinadas por la asamblea, las aportaciones extraordinarias
            que sean fijadas, las cuales serán inaplazables.<br /><strong
              >b)
            </strong>
            Los donativos, herencias, legados y en general cualquier
            contribución que le hagan las personas físicas o morales, nacionales
            o extranjeras, con total independencia del instrumento legal
            empleado y los subsidios que le sean concedidos por la federación,
            los estados y los municipios.<br /><strong>c) </strong> Los
            emolumentos que perciba por servicios prestados o actividades
            empresariales.<br /><strong>d) </strong> Los rendimientos y
            productos que sus bienes generen.<br /><strong>e) </strong>
            Los bienes muebles e inmuebles y derechos que adquieran por
            cualquier titulo legal.
          </p>
          <p>
            <strong>Artículo quinto.- </strong>
            Cuando por circunstancias especiales el Colegio cuente con recursos
            económicos extraordinarios, ya sea resultado de gestiones del
            Consejo Directivo o producto de una donación, estos serán
            considerados como patrimonio, ya sean destinados al colegio o a sus
            miembros, estos serán manejados bajo el esquema financiero de un
            fideicomiso o la figura legal que aplique y con el conocimiento y
            aprobación de la asamblea. La disposición de estos fondos se hará a
            solicitud expresa del Presidente de Consejo y deberá ser aprobada
            por mayoría por el Comité de Vigilancia integrado por cinco miembros
            electos por la asamblea, quienes tienen a su cargo la supervisión
            del correcto ejercicio de los mismos.
          </p>
          <h2>Capítulo 2. De los Objetivos y Facultades.</h2>
          <p>
            <strong>Artículo sexto.- </strong>Los objetivos generales y
            particulares del Colegio de Arquitectos Tabasqueños, A.C., serán:
          </p>
          <p>
            1. Promover una mayor presencia del Arquitecto ante la autoridad, la
            academia y la sociedad.<br />1.1. Fomentar canales de comunicación
            ante las diversas instancias, donde el quehacer del Arquitecto tiene
            trascendencia.<br />1.2. Fomentar el trabajo del Arquitecto hacia la
            comunidad, y las áreas de gobierno relacionadas con la planeación y
            la construcción.<br />1.3. Vincular al Colegio con los centros
            educativos de formación profesional.<br />1.4. Consolidar el
            quehacer arquitectónico como referente del sector de la industria de
            la Construcción y el Desarrollo Urbano.<br />2. Lograr que el
            Colegio se convierta en un espacio de encuentro, superación
            profesional, y desarrollo humano integral.<br />2.1. Incentivar la
            participación en la vida del Colegio mediante la elaboración de
            propuestas orientadas a mejorar la calidad del ejercicio
            profesional.<br />2.2. Constituirse como el espacio idóneo para la
            defensa de los intereses tanto individuales como colectivos de sus
            miembros, respetando los principios éticos y legales que nos
            rigen.<br />2.3. Promover la solidaridad y compañerismo de los
            Arquitectos en las esferas profesional, social y familiar.<br />2.4.
            Procurar los recursos necesarios para la realización de sus
            funciones gremiales y sociales.
          </p>
          <p>
            <strong>Artículo séptimo.- </strong>Son facultades del Colegio de
            Arquitectos Tabasqueños, A.C., conforme al artículo 47 de la Ley
            Reglamentaria de los artículos 4° y 5° de la Constitución Federal
            relativa al ejercicio de las profesiones en el estado de Tabasco,
            las siguientes:
          </p>
          <p>
            1. Auxiliar a la administración pública con capacidad para promover
            lo conducente a la moralización de la misma.<br />2. Fomentar la
            cultura y las relaciones con los Colegios similares del país o
            extranjeros.<br />3. Representar al Colegio ante la Federación de
            Colegios de Arquitectos de la República Mexicana A.C. y la Dirección
            General de Profesiones. <br />4. Ser gestor representante ante las
            instituciones Federales, Estatales y Municipales, organismos
            intermedios de representación, organismos particulares, así como
            ante la sociedad a la que el Colegio preste sus servicios. <br />5.
            Prestar la más amplia colaboración al poder público como cuerpo
            consultor. <br />6. Formar listas de peritos profesionales, por
            especialidades, que serán las únicas que sirvan oficialmente, cuando
            la autoridad lo solicite. <br />7. Velar por que los puestos
            públicos en los que se requieran conocimientos técnicos de
            Arquitectura, estén desempeñados por Arquitectos con titulo
            legalmente expedido y debidamente registrado. <br />8. Promover
            entre nuestra comunidad el desarrollo de la actividad profesional y
            el reconocimiento a la labor de los Arquitectos pertenecientes al
            Colegio. <br />9. Establecer posiciones y propuestas específicas
            ante condiciones que afecten la actividad profesional de la
            Arquitectura en los ámbitos municipales y en nuestro estado.
            <br />10. Velar ante las instancias correspondientes, que los
            proyectos arquitectónicos sean elaborados por Arquitectos con título
            legalmente expedido y debidamente registrados. <br />11. Colaborar
            en la elaboración de los planes de estudios profesionales cuando se
            los solicite el gobierno del estado, o los centros educacionales que
            funcionen en la entidad. <br />12. Promover la capacitación entre
            los diferentes miembros que integran el Colegio, con el fin de
            consolidar el desarrollo y superación de los mismos. <br />13.
            Hacerse representar en los congresos relativos al ejercicio
            profesional de la práctica de la Arquitectura. <br />14. Promover la
            expedición de Leyes, reglamentos y sus reformas, relativos al
            ejercicio profesional. <br />15.Proponer los aranceles
            profesionales. <br />16. Gestionar el registro de los títulos de los
            integrantes del Colegio para profesionalizar la actividad del
            Arquitecto. <br />17. Integrar todos los profesionales de la
            Arquitectura existente en el estad. <br />18.Atender las funciones
            que la dirección general de profesionales le confieren. <br />19.
            Organizar y llevar el registro estatal de servicio social
            profesional que deben presentar los miembros de la asociación.
            <br />20. Vigilar que el ejercicio profesional de la práctica de la
            Arquitectura se realice estrictamente dentro del marco legal, moral
            y profesional. <br />21. Denunciar ante la Dirección de Profesiones
            o a las autoridades correspondientes, las violaciones de la Ley
            Reglamentaria de los artículos 4º y 5º de la Constitución Federal.
            <br />22. Servir de árbitro en los conflictos entre profesionales o
            entre estos y sus clientes, cuando ambos acuerden someterse ha dicho
            arbitraje. <br />23. Promover y vigilar ante las autoridades
            municipales, estatales y federales correspondientes, las
            disposiciones legales para el adecuado desarrollo del ejercicio
            profesional de la práctica de la Arquitectura. <br />24. Actuar en
            apoyo y respaldo por consenso de los integrantes del Colegio, a una
            problemática o propuesta específica que afecte a un miembro en
            particular. <br />25. Establecer posiciones y propuestas específicas
            ante condiciones que afecten la actividad profesional de la
            Arquitectura en los ámbitos municipales y en nuestro estado.
            <br />26. Expulsar, por el voto de dos terceras partes de los
            miembros, a los que ejecuten actos que desprestigien o deshonren a
            la profesión. Siendo requisito en todo caso, el oír al interesado y
            darle plena oportunidad de rendir las pruebas que estime
            convenientes. <br />27. Intensificar las relaciones entre los
            miembros del Colegio del estado de Tabasco, con el fin de lograr un
            acercamiento entre los agremiados. <br />28. Adquirir por compra,
            arrendamiento, donación o cualquier medio legal, los bienes muebles
            e inmuebles para realizar los objetivos sociales en general,
            ejecutar y celebrar los actos y contratos que tengan por finalidad
            el cumplimiento estricto de toda asociación. <br />29. Establecer
            programas financieros y planes de acción que le permitan disponer de
            los recursos económicos para lograr sus objetivos.
          </p>
          <h2>Capítulo 3. De las Delegaciones y Filiales</h2>
          <p>
            <strong>Artículo octavo</strong>
            .- El Colegio de Arquitectos Tabasqueños A.C. podrá contar con
            Delegaciones formadas por Arquitectos residentes en diversos
            municipios, diferentes al de centro, las que tendrán una
            organización semejante a la del Colegio y que deberán funcionar en
            forma similar respetando los estatutos y reglamentos del Colegio,
            las Delegaciones tendrán jurisdicción en un solo municipio o en
            varios colindantes.
          </p>
          <p>
            <strong>Artículo noveno.- </strong>
            Los Arquitectos que no residan en la ciudad sede de la Delegación,
            podrán formar parte de ella si tienen establecido su domicilio
            dentro de la jurisdicción de dicha Delegación, gozando de todos los
            derechos inherentes y de los que confiera el Colegio, siempre que
            cumplan con las obligaciones estatutarias.
          </p>
          <p>
            <strong>Artículo décimo.- </strong>
            Las sociedades de Arquitectos legalmente establecidas en los
            municipios podrán constituirse en filiales del Colegio si así lo
            solicitan.
          </p>
          <p>
            <strong>Articulo décimo primero.- </strong>
            Las filiales municipales y las Delegaciones serán los órganos en que
            deberán agruparse los Arquitectos para constituir el nexo adecuado
            entre sus miembros y el Colegio, y tendrán los mismos objetivos
            establecidos en el presente estatuto.
          </p>
          <p>
            <strong>Artículo décimo segundo.- </strong>
            Los miembros de las Delegaciones y Filiales podrán hacer uso del
            título: miembro del Colegio de Arquitectos Tabasqueños A.C.
          </p>

          <h2>Capítulo 4. De los miembros</h2>
          <p>
            <strong>Artículo décimo tercero.-</strong> Los miembros del Colegio
            de Arquitectos Tabasqueños A.C. serán:
          </p>
          <p>
            a) Miembros de número: los profesionistas Arquitectos, Licenciado en
            Arquitectura, Ingenieros Arquitectos o urbanistas autorizados con
            cédula profesional y residentes del estado de Tabasco de conformidad
            con los artículos 41 de la Ley Reglamentaria de los artículos 4º y
            5º de la Constitución Federal relativa al ejercicio de las
            profesiones en el estado de Tabasco.
          </p>
          <p>
            b) Miembros Pasantes: los pasantes de la carrera de Arquitecto,
            Licenciado en Arquitectura, Ingeniero Arquitecto o Urbanistas
            autorizados por la dirección General de Profesiones de la Secretaria
            de Educación Pública, para ejercer la práctica respectiva en los
            términos que señala el artículo 29 del capítulo V de la Ley
            Reglamentaria de los artículos 4º y 5º de la Constitución Federal
            relativa al ejercicio de las Profesiones en el Estado de Tabasco.
          </p>
          <p>
            <strong>Articulo décimo cuarto.-</strong> De la admisión, para su
            admisión, los aspirantes, podrán solicitar al Colegio de Arquitectos
            Tabasqueños A.C., su admisión, bajo los siguientes requisitos:
          </p>
          <p>
            a) Solicitud por escrito, manifestando su interés por pertenecer al
            Colegio y su aceptación a los presentes estatutos y el código de
            ética.
          </p>
          <p>
            b) Los Miembros de Número presentaran copia del título de una
            escuela profesional de Arquitectura, ingeniero Arquitecto o
            urbanismo reconocida por la Secretaria de Educación Pública, además
            copia de la cédula profesional y curriculum actualizado.
          </p>
          <p>
            c) Los Miembros Pasantes, presentarán copia certificada de la carta
            de pasante debidamente autorizada por la dirección General de
            Profesiones, en los términos del artículo 29 del capítulo V de la
            Ley Reglamentaria de los artículos 4º y 5º de la Constitución
            Federal relativa al ejercicio de las Profesiones en el Estado de
            Tabasco.
          </p>
          <p>d) Cubrir su cuota de inscripción.</p>
          <p>
            e) Tener domicilio permanente en el estado de Tabasco, con
            residencia mínima de dos años.
          </p>
          <p>
            f) Presentar carta de recomendación de un miembro de número con
            derechos vigentes.
          </p>
          <p>
            La aceptación de los miembros estará facultada al Consejo Directivo.
            En el caso de alguna objeción, deberá ser interpuesta en la Junta de
            Honor y Justicia.
          </p>
          <p>
            <strong>Artículo décimo quinto.-</strong> De las obligaciones de los
            miembros: los miembros de número del Colegio de Arquitectos
            Tabasqueños A.C., tendrán las siguientes obligaciones:
          </p>
          <p>
            a) Respetar y hacer respetar los estatutos y reglamentos del
            Colegio.
          </p>
          <p>
            b) Procurar por todos los medios, el prestigio y progreso del
            Colegio, contribuyendo eficazmente a la realización de sus fines.
          </p>
          <p>
            c) Cubrir las cuotas eficaz y oportunamente. Cuando alguno de los
            miembros deja de cubrir su cuota, estas serán acumuladas hasta la
            fecha de solicitar de nuevo su reingreso, debiendo, para obtenerlo
            ponerse al corriente de sus obligaciones.
          </p>
          <p>
            d) Cumplir y hacer cumplir en todo momento los principios que señala
            el código de ética profesional del Colegio y la Federación de
            Colegios de Arquitectos de la República Mexicana.
          </p>
          <p>
            e) Cumplir con la asistencia puntual a las asambleas generales
            ordinarias y extraordinarias a que sean convocados, de conformidad a
            lo señalado en el reglamento.
          </p>
          <p>f) Informar oportunamente de los cambios de su domicilio.</p>
          <p>
            g) Cumplir con el servicio social profesional de acuerdo a lo
            previsto por la Ley Reglamentaria de los artículos 4º y 5º de la
            Constitución Federal relativa al ejercicio de las profesiones en el
            Estado de Tabasco.
          </p>
          <p>
            h) Cumplir con las comisiones que le sean conferidas por el consejo,
            y desempeñar las funciones que el mismo le asigne.
          </p>
          <p>
            i) Será obligatorio para todos los miembros del Colegio asistir por
            lo menos a dos de las asambleas generales ordinarias al año.
          </p>
          <p>
            j) Cumplir con los cursos de actualización profesional anuales de
            acuerdo a lo establecido por la Federación de Colegios de
            Arquitectos de la República Mexicana A.C.
          </p>
          <p>
            k) Las demás obligaciones que emanen de los acuerdos legalmente
            emitidos por la asamblea general y los Órganos de Gobierno del
            Colegio.
          </p>
          <p>
            <strong>Artículo décimo sexto.-</strong> Son derechos de los
            miembros de número del Colegio de Arquitectos Tabasqueños A.C.:
          </p>
          <p>
            a) Utilizar todos los servicios que establezca el Colegio en
            beneficio de sus miembros.
          </p>
          <p>
            b) Tener voz y voto en todos los asuntos que se traten en las
            asambleas, siempre y cuando estén al corriente de sus cuotas y
            obligaciones.
          </p>
          <p>c) Ser merecedor a los reconocimientos del Colegio.</p>
          <p>
            d) Tomar parte en las actividades del Colegio, pudiendo presentar
            iniciativas y proposiciones.
          </p>
          <p>
            e) Ser informados de las gestiones administrativas del Colegio,
            otorgándoseles acceso a la contabilidad y documentos respectivos.
          </p>
          <p>
            f) Utilizar en el membrete de su correspondencia la calidad y
            denominación específica que le corresponde, conforme a los
            estatutos.
          </p>
          <p>g) Ser electo para los cargos del Consejo Directivo.</p>
          <p>
            h) Solicitar la suspensión de obligaciones por cambio temporal de
            residencia, sin perder sus derechos. El plazo máximo de ésta, será
            de dos años, la cual se solicitará mediante un escrito de exposición
            de motivos, y quedará sujeta a la aprobación del Consejo Directivo.
          </p>
          <p>Son derechos de los miembros pasantes:</p>
          <p>
            a) Los miembros pasantes, tendrán los mismos derechos que los
            miembros de número, pudiendo participar en las comisiones de trabajo
            que establezca el Colegio, pero no podrán ser elegibles para
            desempeñar ningún cargo dentro del Consejo Directivo, ni fungir como
            electores ni ser vitalicios. En las asambleas no tendrán derecho a
            voto ni podrán participar en el referéndum referido.
          </p>
          <p><strong>Artículo decimoséptimo.-</strong> Aportaciones.</p>
          <p>
            <strong>a) Cuota anual.-</strong> Se establece como obligatoria una
            cuota anual, que deberá cubrirse en los dos primeros meses de cada
            año. El importe de esta cuota se establecerá en base a los gastos de
            operación del Colegio, y se someterá a aprobación de la asamblea. En
            caso de no efectuarse a tiempo dicho pago este se incrementará según
            lo acordado por la Asamblea.
          </p>
          <p>
            <strong>b) Cuotas extraordinarias.-</strong> Serán aquellas, que
            aprobadas por la asamblea, se destinen a los gastos de eventos
            especiales, compromisos gremiales, cooperaciones etc., y su pago
            será obligatorio.
          </p>
          <p>
            <strong>c) Aportaciones gremiales.-</strong> Los colegiados tendrán
            la obligación de aportar:
          </p>
          <p>
            1. El 4% (cuatro por ciento) de los ingresos por trabajos de
            proyectos obtenidos, por intervención directa del Colegio o
            derivados de convenios entre el Colegio y diversas dependencias, ya
            sean mediante concursos, asignaciones o designaciones específicas,
            mismo que será calculado sobre el monto facturado.
            <br />
            2. El 2% (dos por ciento) de los ingresos por trabajos de
            construcción obtenidos, por intervención directa del Colegio o
            derivados de convenios entre el Colegio y diversas dependencias, ya
            sean mediante concursos, asignaciones o designaciones específicas,
            mismo que será calculado sobre el monto facturado.
            <br />
            3. El 10% del arancel de director responsable de obra y
            corresponsables.
          </p>
          <h2>Capítulo 5. De los Órganos de Gobierno</h2>
          <p>
            <strong>Artículo décimo octavo.-</strong> Los Órganos de Gobierno
            del Colegio de Arquitectos Tabasqueños A.C., se establecen en cuatro
            niveles y son:<br />
            a) La asamblea general.<br />
            b) El Consejo Directivo.<br />
            c) La Junta de Honor y Justicia.<br />
            d) El Consejo Consultivo.
          </p>
          <p>
            <strong>Artículo décimo noveno.-</strong> La asamblea general es el
            órgano supremo del Colegio y es quien determina las políticas y
            programas a seguir. Se integrará mediante convocatoria pública con
            los miembros del Colegio debidamente acreditados ante la secretaria
            general, conforme al quórum que determinen estos estatutos.
          </p>
          <p>
            <strong>Articulo vigésimo.- </strong>
            El Consejo Directivo es el órgano de gobierno permanente a cuyo
            cargo estarán las actividades directivas, ejecutivas y
            administrativas del Colegio y se integrará de acuerdo con las
            disposiciones; de la Ley Reglamentaria de los artículos 4° y 5° de
            la Constitución Federal relativa al ejercicio de las profesiones en
            el estado de Tabasco y las contenidas en las disposiciones
            reglamentarias de estos estatutos.
          </p>
          <p>
            <strong>Articulo vigésimo primero.- </strong>
            La Junta de Honor y Justicia, es el órgano normativo de vigilancia,
            justicia y apoyo del Colegio. Está integrada por los últimos cinco
            ex-Presidentes, quienes ocuparan los cargos de Presidente y cuatro
            consejeros; la presidencia la ocupara el consejero que con más
            antigüedad haya ejercido el puesto de Presidente del Colegio.
          </p>
          <p>
            a) La Junta de Honor y Justicia, aplicara las sanciones a que se
            hagan acreedores los miembros por infringir los presentes estatutos
            o por contravenir lo dispuesto en el código de ética profesional.
          </p>
          <p>
            b) Para cumplir con sus atribuciones la Junta de Honor y Justicia,
            se reunirá las veces que sean necesarias, con la presencia mínima de
            la mitad mas uno de los miembros que la integran y sus acuerdos
            serán tomados por mayoría de votos.
          </p>
          <p>
            c) Podrá convocar a asamblea extraordinaria, cuando se les solicite
            por escrito un mínimo de un 20% de los miembros de número al
            corriente de sus obligaciones.
          </p>
          <p>
            d) Los cargos de los miembros de la Junta de Honor y Justicia, serán
            honoríficos.
          </p>
          <p>
            e) En caso de que por cualquier circunstancia faltase de manera
            definitiva alguno de sus miembros, el Consejo Directivo presentará
            una terna de miembros que cumplan los requisitos, entre los cuales,
            uno será elegido por la propia Junta de Honor y Justicia para suplir
            al faltante.
          </p>
          <p>
            <strong>Artículo vigésimo segundo.- </strong>
            El Consejo Consultivo es el órgano permanente de consulta, promoción
            y asesoría del Colegio, el cual estará integrado por todos los ex
            Presidentes y será presidido por un miembro, electo por sus
            integrantes, quien durara en el cargo el periodo igual al del
            Consejo Directivo en funciones.
          </p>
          <p>
            a) Podrán ser integrantes a invitación expresa y aceptación por el
            mismo Consejo Consultivo, los miembros distinguidos del Colegio que
            hayan ocupado cargos en alguno de los consejos directivos.
          </p>
          <p>
            b) Los miembros del Consejo Consultivo mayores de 65 años, que así
            lo deseen, quedarán exentos de los cursos de actualización
            profesional.
          </p>
          <h2>Capítulo 6. De las asambleas</h2>
          <p>
            <strong>Artículo vigésimo tercero.- </strong>
            Las sesiones de asamblea general podrán ser ordinarias o
            extraordinarias.<br />
            El Consejo Directivo en funciones, deberá cumplir con la realización
            de cuatro asambleas ordinarias al año, las cuales se realizarán en
            los meses que a continuación se citan: En años pares se deberán
            calendarizar en los meses de abril, julio, octubre y diciembre y
            para los años nones en los meses de marzo, junio, septiembre y
            diciembre. Las fechas definitivas serán notificadas a los agremiados
            con 30 días de anticipación.
            <br />El calendario anual de asambleas se deberá presentar en la
            primera asamblea ordinaria del año.
          </p>
          <p>
            <strong>a) Las sesiones de asamblea general ordinaria.</strong>
            Tienen como objetivo el conocimiento de los informes trimestrales de
            actividades, del Consejo Directivo, así como para tratar los asuntos
            especificados en la convocatoria, de acuerdo a lo previsto en el
            artículo vigésimo séptimo de estos estatutos y comprenderán:
            <br />
            1. Informe de actividades desarrolladas.
            <br />
            2. Balance del ejercicio social.
            <br />
            3. Programas de actividades y presupuestos de ingresos y egresos.
            <br />
            4. Resolver sobre la exclusión o suspensión de miembros.
            <br />
            5. Resolver las iniciativas que por su importancia ponga a
            consideración el Consejo Directivo.
            <br />
            6. Conocer todas las resoluciones tomadas por el Consejo Directivo y
            por la Junta de Honor y Justicia en relación a modificaciones de
            estatutos.
            <br />
            7. Conocer y vigilar las actividades de las Delegaciones y Filiales,
            las cuales se regirán conforme a las disposiciones de los estatutos.
            <br />
            8. Así como del resultado de las elecciones y la toma de protesta
            del Consejo Directivo en los años pares.
          </p>
          <p>
            <strong>b) Las asambleas extraordinarias comprenderán:</strong>
            <br />
            1. Las asambleas extraordinarias deberán ser convocadas de acuerdo a
            lo previsto en el artículo vigésimo séptimo de los presentes
            estatutos.
            <br />
            2. Conocer, discutir y resolver toda iniciativa presentada por
            escrito a la consideración del Colegio y que no haya sido
            contemplada en la asamblea ordinaria.
            <br />
            3. Resolver las iniciativas que por su importancia y urgencia estime
            el Consejo Directivo poner a consideración de la asamblea.
            <br />
            4. Discutir y resolver los asuntos relacionados con las
            modificaciones y adiciones a los estatutos del Colegio.
            <br />
            5. Sancionar a los miembros cuando lleven a cabo actividades fuera
            de sus objetivos, no colaboren en la promoción de actividades o se
            nieguen a actuar como árbitros mediadores cuando se les solicite,
            así mismo podrá sancionar con destitución del cargo a uno o a todos
            los integrantes del Consejo Directivo cuando incumplan obligaciones
            y desconozcan el objeto principal del colegio.
          </p>
          <p>
            6. Resolver los asuntos concernientes al aspecto legal del Colegio
            en cuanto a:
          </p>
          <p>
            6.1.- Disolución
            <br />
            6.2.- Cambio de domicilio
            <br />
            6.3.- Cambio de denominación.
            <br />6.4.- Cambio de objetivos
            <br />
            6.5.- Nombramiento y facultades que se consideran a los liquidadores
            y resolver sobre las aplicaciones de los bienes.
          </p>
          <p>
            <strong>Artículo vigésimo cuarto.- </strong>
            La convocatoria para una asamblea general ordinaria, será formulada
            por el Consejo Directivo, autorizada por el Presidente y convocada
            por el Secretario General.
          </p>
          <p>
            <strong>Artículo vigésimo quinto.-</strong> La convocatoria para una
            asamblea extraordinaria, será formulada por el Consejo Directivo,
            conforme a lo estipulado en el artículo trigésimo segundo.
          </p>
          <p>
            También podrán ser convocadas por la Junta de Honor y Justicia, será
            presidida por su Presidente, o por algún otro miembro de este
            órgano, designado por él.
          </p>
          <p>
            <strong>Artículo vigésimo sexto.- </strong>
            La Junta de Honor y Justicia podrá convocar a asamblea
            extraordinaria, por los siguientes motivos:
          </p>
          <p>
            1. Cuando el Consejo Directivo no convoque oportunamente a la
            asamblea general ordinaria o se niegue a convocarla con carácter de
            extraordinaria.<br />2. Cuando lo solicite y fundamente por escrito,
            un mínimo de un 20% de los miembros de numero al corriente de sus
            obligaciones.
          </p>

          <p>
            <strong>Artículo vigésimo séptimo.-</strong>Las convocatorias para
            las asambleas, deberán cumplir con los siguientes requisitos:
          </p>
          <p>
            1. La convocatoria para una asamblea general ordinaria o
            extraordinaria se hará mediante la publicación en uno de los
            periódicos diarios de mayor circulación del estado, por lo menos con
            tres días de anticipación, sin perjuicio que se ratifique a los
            agremiados directamente por los medios de comunicación que quien
            convoque, considere pertinentes. <br />2. La convocatoria para una
            asamblea general ordinaria contendrá el orden del día de la misma,
            definiendo el lugar, la fecha y la hora previstas para su
            celebración, y deberá ser signada por quien convoca, de acuerdo a lo
            establecido en el artículo vigésimo cuarto. Dicho Orden del día,
            deberá contener los puntos que a continuación se enumeran: <br />
            I. Recepción y registro.<br />
            II. Lista de asistencia.<br />
            III. Declaración del quorum.<br />
            IV. Lectura y aprobación del orden del día.<br />
            V. Lesctura de acuerdos de la asamblea anterior.<br />
            VI. Informe del presidente.<br />
            VII. Informe del tesorero.<br />
            VIII. Informe de las secretarias.<br />
            IX. Asuntos Generales.<br />
            X. Acuerdos.<br />
            XI. Clausura.
          </p>
          <p>
            En caso de ser necesario, el convocante podrá incluir en el cuerpo
            de la convocatoria uno o varios puntos específicos a tratar en la
            Asamblea.<br />
            La convocatoria para una asamblea deberá de cumplir con el
            procedimiento descrito a continuación:
          </p>
          <p>
            3. La segunda convocatoria para una asamblea extraordinaria, deberá
            cumplir con el mismo procedimiento establecido en el inciso 1 de
            este artículo.<br />
            4. La convocatoria para una asamblea deberá de cumplir con el
            procedimiento descrito a continuación:
          </p>
          <h3>I. Recepción y registro</h3>
          <p>
            El registro se iniciará desde las 7:00 pm, con el objeto de que se
            recaben las firmas y documentación correspondiente, tomando en
            consideración los puntos siguientes:
          </p>
          <p>
            a) La lista de asistencia deberá realizarse en papel membretado del
            Colegio debidamente foliado.
            <br />
            b) La lista de asistencia contendrá las siguientes columnas: número
            consecutivo; número colegiado; número de asistencias en el año
            desglosadas por fechas; al corriente de sus pagos (si) (no); nombre
            completo; y la firma autógrafa con tinta azul, que se recabara a los
            colegiados en el momento de su registro.
            <br />
            c) Se realizará la entrega de constancia de no adeudo, al agremiado
            que lo solicite, misma que se otorgará hasta las 7pm del día de la
            asamblea, para contar con esta constancia; los pagos de las cuentas
            pendientes se tendrán que liquidar a más tardar a las 2:00 pm del
            día de la Asamblea, en caso de ser transferencias bancarias deberán
            notificarse a la tesorería en el mismo limite especificado, con el
            objeto de que se elabore las constancias correspondientes con
            oportunidad.
            <br />
            d) Se entregará a cada colegiado con derecho a voz y voto, una
            boleta verde para voto positivo y boleta roja para voto negativo, la
            cual estará debidamente firmada por el Secretario y el Tesorero con
            sello del Colegio. Las cuáles serán personales e intransferibles.
            <br />
            e) En punto de las 8:00 pm. Se deberá entregar lista al Secretario.
            <br />
            f) Todos los miembros de número podrán asistir a la asamblea
            general, pero solo tendrán derecho a voz y voto los miembros que
            estén al corriente de sus obligaciones con el Colegio de acuerdo a
            lo establecido en el artículo décimo quinto de los estatutos
            vigentes, quedando estrictamente prohibida la presencia de personas
            ajenas a la asamblea a menos que en algún punto de la convocatoria
            publicada se prevea su participación.
          </p>
          <h3>II. Lista de asistencia.</h3>
          <p>
            a. En primera convocatoria, en punto de las 8:00 pm. Se realizará el
            anuncio de estatus del quorum. Debiendo elegir de entre los
            presentes dos escrutadores para auxiliar al Secretario General en
            los conteos de la asamblea, estos escrutadores deberán ser ajenos al
            Consejo Directivo y miembros con derecho a voz y voto de la
            Asamblea. <br />b. En segunda convocatoria, en punto de las 8:30 pm,
            se procederá al cierre de la lista. A continuación de procederá al
            pase de lista de asistencia. <br />c. Se deberá consignar en la
            lista de asistencia, las faltas con la palabra FALTA en la columna
            de firmas con tinta roja. <br />d. El Secretario General deberá
            validar la lista de asistencia con la firma autógrafa en tinta azul
            en cada hoja, en presencia de los escrutadores nombrados por la
            asamblea.
          </p>
          <h3>III. Declaración del quorum.</h3>
          <p>
            El Secretario General llevará a cabo la declaración del quorum para
            la asamblea con el anuncio del número de colegiados asistentes,
            especificando cuantos son los miembros al corriente de sus
            obligaciones y de éstos qué porcentaje asistió, el quórum oficial se
            apegará a lo establecido en el Artículo Trigésimo tercero.
          </p>
          <h3>IV. Lectura y aprobación del orden del día.</h3>
          <p>
            El Orden del Día deberá corresponder al publicado y no será
            modificado a menos de que la Asamblea disponga lo contrario.
          </p>
          <h3>V. Lectura de acuerdos de la asamblea anterior.</h3>
          <p>
            Se dará lectura a los acuerdos de la asamblea anterior, con la
            finalidad de informar a los agremiados del seguimiento de las
            resoluciones de las mismas.
          </p>
          <h3>VI. Informe del presidente.</h3>
          <p>
            a) La estructura del informe del Presidente debe de contemplar los
            eventos relevantes para la vida del Colegio y hacerlos del
            conocimiento de los agremiados, enfocado a los beneficios o
            compromisos que estas actividades le acarrean al gremio. <br />b) El
            Presidente deberá plantear de igual manera, las acciones en las que
            el Colegio está trabajando y de cuales solicite el apoyo del gremio.
          </p>
          <h3>VII. Informe del tesorero.</h3>
          <p>
            a) Debe de contemplar lo establecido en el artículo trigésimo noveno
            numeral 4. <br />b) En la primera asamblea del consejo directivo
            entrante, deberá informar el estado que guarda el patrimonio del
            CAT, así como en la última asamblea extraordinaria del periodo que
            le corresponda. <br />c) Todos estos informes serán puestos a
            disposición de los colegiados para su consulta tanto en medios
            electrónicos como documentales.
          </p>
          <h3>VIII. Informe de las secretarias.</h3>
          <p>
            Deberá de contemplar lo establecido en el artículo trigésimo noveno
            numeral 5, 6, 7.
          </p>
          <h3>IX. Asuntos generales.</h3>
          <p>
            Serán los que previo a la Asamblea se soliciten de forma oficial por
            escrito ante el Secretario General.
          </p>
          <p>
            El secretario General deberá de incluir dichos asuntos en el orden
            del día e informar a la Asamblea los puntos específicos a tratar, y
            el solicitante una vez en el uso de la voz, deberá apegarse al tema
            solicitado caso contrario se le retirará el uso de la voz.
          </p>
          <p>
            Los Asuntos Generales solicitados y aprobados, serán consignados
            debidamente en las actas de Asamblea.
          </p>
          <h3>X. Acuerdos.</h3>
          <p>
            Los puntos de acuerdo que se sometan a votación, deberán ser
            aprobados por mayoría de acuerdo a lo establecido en el Art.
            Trigésimo Tercero. Para el conteo de los votos, se designará por
            parte de la asamblea dos escrutadores, los cuales serán los
            encargados junto con el Secretario General de validar la votación.
          </p>
          <p>
            Se establecerá en el orden del día de la convocatoria la lectura de
            los acuerdos, se asentarán en el libro de actas y dará lectura en el
            pleno de la asamblea, previo a la clausura de la misma y
            posteriormente se firmará por los asistentes el libro, de acuerdo al
            artículo vigésimo noveno.
          </p>
          <p>
            En la asamblea siguiente el Consejo Directivo deberá informar de los
            avances de dichos acuerdos. La lectura de los acuerdos del acta
            anterior, se deberá de incluir dentro del orden del día.
          </p>
          <h3>XI. Clausura</h3>
          <p>
            Agotado el orden del día y una vez leídos y aprobados los acuerdos y
            asentados en el libro de actas, se dará por clausurada la Asamblea y
            se firmará por los asistentes el libro de actas.
          </p>
          <p>
            <strong>Articulo vigésimo octavo.-</strong> En ausencia del
            Presidente, las asambleas deberán ser presididas por el vice
            Presidente, y en ausencia de este, por otro miembro del Consejo
            Directivo, designado previamente por el Presidente.
          </p>
          <p>
            Artículo vigésimo noveno.- Los acuerdos de las asambleas se harán
            constar en las actas, que se llevaran por orden cronológico en los
            libros correspondientes. <br />Las actas serán autorizadas por el
            Presidente y el Secretario propietario y por los escrutadores
            nombrados con anterioridad, mismas que deberán ser suscritas por
            todos los miembros asistentes. <br />Las actas quedarán en resguardo
            en el Colegio de Arquitectos, para su consulta y serán publicadas
            para conocimiento de los agremiados de acuerdo a los siguientes
            procedimientos:
          </p>
          <p>
            a. La lista de asistencia de la Asamblea, deberá hacerse del
            conocimiento de los colegiados por medios electrónicos e impresos y
            exhibidos en la sede del CAT, al día siguiente. <br />b. Los
            acuerdos de la asamblea, de igual manera se harán del conocimiento
            de los agremiados por medios electrónicos, y el libro quedara a
            disposición de los colegiados para su consulta al día siguiente.
            <br />c. Todas las incidencias de la asamblea, es decir lista de
            asistencia, informes y acuerdos deberán estar disponibles para su
            consulta, físicamente y de manera electrónica, al día siguiente del
            evento.
          </p>

          <p>
            <strong>Artículo trigésimo.-</strong> Solo los miembros del Colegio
            que estén al corriente de sus obligaciones gremiales que se incluyen
            en el artículo decimoséptimo y que hayan asistido a por lo menos dos
            de las cuatro asambleas previas a la asamblea convocada, tendrán voz
            y voto.
          </p>

          <p><strong>Artículo trigésimo primero.-</strong> Derogado.</p>

          <p>
            <strong>Artículo trigésimo segundo.-</strong> Será obligación del
            Consejo Directivo el convocar a cuatro asambleas generales
            ordinarias trimestrales por año y al número de asambleas
            extraordinarias que sean requeridas. Será obligatorio para todos los
            miembros del Colegio asistir por lo menos a dos de las asambleas
            generales ordinarias.
          </p>

          <p>
            <strong>Artículo trigésimo tercero.-</strong> El quórum exigido para
            que las decisiones de la asamblea sean válidas y que se celebren por
            primera convocatoria será del 50% más uno del padrón de los miembros
            con derecho a voto. En segunda convocatoria el quórum se integrará
            por los miembros con derecho a voto que asistan y las resoluciones
            serán válidas con la aprobación del 50% más uno del quórum presente.
            En los casos relacionados al patrimonio del colegio, que se detalla
            en el artículo cuarto, Incisos b, c, d y e, dicha votación se deberá
            realizar con la asistencia del 75% de los miembros con derecho a
            voto y la votación se considerará valida con la aprobación del 50%
            de este quorum.
          </p>

          <p>
            <strong>Artículo trigésimo cuarto.-</strong> Cuando se trate de
            disolución, derogación, cambio de objetivos o modificación de
            estatutos se requerirá la presencia del 75% de los miembros con
            derecho a voto, de acuerdo al artículo quincuagésimo cuarto.
          </p>

          <h2>Capítulo 7.</h2>

          <p>
            <strong>Articulo trigésimo quinto.-</strong> Para el cumplimiento de
            sus objetivos el Colegio de Arquitectos Tabasqueños A.C., estará
            dirigido y administrado por un Consejo Directivo, este consejo
            estará integrado por un Presidente, un Vice Presidente, un
            Secretario General, un Secretario General suplente, un Tesorero, un
            Pro-tesorero, los Secretarios de Acción Gremial, de Superación
            Profesional y el Vocal de Acción Urbana, mismos que duraran en el
            cargo dos años.<br />

            Los cargos de todos los miembros del Consejo Directivo serán
            honoríficos.<br />

            Los gastos de representación para asistir a eventos oficiales del
            Colegio, exclusivamente para transporte y hospedaje del Presidente o
            su representante, serán cubiertos por el Colegio.
          </p>

          <p>
            <strong>Articulo trigésimo sexto.-</strong> Las personas que
            integran el Consejo Directivo duraran en funciones dos años pero
            permanecerán en sus puestos hasta que sus sucesores sean designados
            y tomen posesión.
          </p>

          <p>
            En caso de que por cualquier circunstancia faltase de manera
            definitiva alguno de sus miembros, el Presidente del Consejo
            Directivo propondrá al miembro de número del Colegio, que cumpla con
            los requisitos para ocupar la vacante por el resto del período, y
            deberá ser sometido a la aprobación del Consejo Directivo.
          </p>

          <p>
            <strong>Articulo trigésimo séptimo.-</strong> El Consejo Directivo
            celebrara una sesión ordinaria semanal el día lunes y sesiones
            extraordinarias cuando sean convocados por su Presidente o por dos
            miembros del consejo. Los consejeros deberán asistir sin necesidad
            de ser citados previamente; solo en caso de no efectuarse
            oficialmente serán avisados oportunamente.
          </p>

          <p>
            <strong>Artículo trigésimo octavo.-</strong> Para ser miembro del
            Consejo Directivo se requerirá de:
          </p>
          <p>
            a. Ser miembro de número y estar al corriente en sus
            obligaciones.<br />
            b. Haber sido miembro de número ininterrumpidamente y con la
            participación activa acreditable por lo menos cinco años para la
            presidencia y vicepresidencia, y dos años para los restantes cargos,
            antes de la elección.<br />
            c. No podrá ostentar cargo público al momento de inscribirse para
            elecciones, ni durante el período que dure su gestión en caso de ser
            electo.
          </p>

          <p>
            <strong>Artículo trigésimo noveno.-</strong> Son facultades y
            obligaciones del Consejo Directivo:
          </p>
          <p>
            <strong>1.- Del Presidente:</strong><br />
            a) Presidir las asambleas generales y las sesiones del Consejo
            Directivo.
            <br />b) Llevar la representación del Colegio a los actos oficiales
            en que intervenga. <br />c) Cuidar que se cumplan los acuerdos
            tomados en la asamblea general y del Consejo Directivo. <br />d)
            Autorizar conjuntamente con el tesorero, el pago de los gastos
            aprobados previamente por la asamblea. <br />e) Acordar y despachar
            los asuntos ordinarios del Colegio y los relativos al Consejo
            Directivo. <br />f) Citar a sesión al Consejo Directivo cada vez que
            lo estime conveniente, necesario, o cuando se imponga tal cosa por
            disposición de los presentes estatutos. <br />g) Firmar
            conjuntamente con el secretario, los acuerdos del Consejo Directivo,
            así como las actas de las asambleas generales. <br />h) Gestionar
            cuantos intereses convengan al Colegio y a los fines de este.
            <br />i) Tomar las medidas y urgencias que sean necesarias cuando la
            situación no permita esperar la celebración de una junta o asamblea,
            teniendo obligación de dar cuenta de dicha determinación al Consejo
            Directivo, y en caso de que este lo determine así, a la próxima
            asamblea general que se celebre. <br />j) Nombrar o renovar a los
            miembros de las comisiones de trabajo, a los asesores técnicos y a
            todos los empleados del Colegio. Las remuneraciones al personal
            cuyos servicios se consideren necesarios remunerar, serán sometidas
            previamente por el Presidente a la aprobación del Consejo Directivo.
            <br />k) Firmar toda la correspondencia oficial del Colegio o
            delegar expresamente y por escrito, esta función a los consejeros.
            <br />l) Representar jurídicamente al Colegio, conjuntamente con el
            Secretario General. <br />m) Coordinar las acciones en el ámbito
            municipal, en lo relativo a la política gremial de los Arquitectos
            del estado de Tabasco. <br />n) Firmar las convocatorias a que se
            refieren los artículos relativos de estos estatutos <br />o)
            Representar a los miembros del Colegio ante la Federación de
            Colegios de Arquitectos de la República Mexicana, A.C. <br />p)
            Dirigir las actividades del Colegio de acuerdo a los estatutos y
            programas previamente establecidos.<br />
            q) Las demás atribuciones de los presentes estatutos, que sean
            consecuencia de su encargo.
          </p>

          <p>
            <strong>2.- Del Vice Presidente:</strong><br />
            a) El vice Presidente del Colegio, sustituirá al Presidente durante
            sus ausencias temporales, así mismo, a solicitud del propio
            Presidente lo substituirá en las funciones y cargos que este le
            delegue.
            <br />b) Auxiliar al Presidente en los asuntos que sea requerido, o
            lo acuerde la asamblea general o el Consejo Directivo. <br />c)
            Cuando la ausencia del Presidente del Consejo Directivo fuere
            definitiva, el vice Presidente ocupará el cargo por el resto del
            período, debiendo la asamblea general elegir un nuevo vice
            Presidente por el mismo lapso.
          </p>

          <p>
            <strong
              >3.- Del Secretario General y Secretario General suplente:</strong
            ><br />
            a) Representar jurídicamente al colegio, conjuntamente con el
            Presidente.
            <br />b) Deberá de formular y expedir la convocatoria y órdenes del
            día para las asambleas generales y sesiones del Consejo Directivo y
            de acuerdo con el Presidente, convocara a los miembros del Consejo
            Directivo y a los miembros agremiados del colegio a las juntas y
            asambleas ordinarias y extraordinarias según fuera el caso. <br />c)
            Promover y coordinar tanto el cumplimiento y avances de los acuerdos
            tomados por la asamblea así como la vigencia de los estatutos.
            <br />d) Tener a su cargo los archivos del Colegio, y mantener
            actualizados los libros de actas. El Secretario General suplente
            redactará y leerá las actas de las asambleas generales y las de
            sesiones del Consejo Directivo y tendrá a su cargo los libros de
            actas. <br />e) Mantener actualizado el directorio de colegiados, en
            el que deberán asentarse como mínimo, nombre y apellidos de los
            miembros, numero de afiliación, numero de dro y/o corresponsable,
            fecha de alta, dirección y teléfonos particulares y de oficina,
            teléfono de contacto y dirección de correo electrónico. <br />f)
            Informar al pleno de las juntas y/o asambleas, de los acuerdos
            tomados en las sesiones del Consejo Directivo. <br />g) El
            Secretario General suplente substituirá al Secretario General en sus
            ausencias.
          </p>

          <p>
            <strong>4.- Del Tesorero y Pro-tesorero:</strong><br />

            a) Vigilar que los fondos del Colegio se destinen a los fines del
            mismo.
            <br />b) Informar al pleno de las juntas y/o asambleas la situación
            financiera que guarda el Colegio. <br />c) Informar al pleno, de las
            juntas y/o asambleas los estados de adeudos y no adeudos de los
            colegiados <br />d) Vigilar que el patrimonio del Colegio no
            permanezca improductivo. <br />e) Vigilar que los libros de
            contabilidad que exige la Ley que sean llevados al día, así mismo
            como los registros auxiliares y demás documentos necesarios, a fin
            de que sean corridos oportunamente los asientos que muestren
            claramente el movimiento de fondos y contables del Colegio. <br />f)
            Vigilar que las obligaciones fiscales del Colegio sean atendidas
            oportunamente. <br />g) Revisar y autorizar el balance anual
            auditado que deberá presentarse en la asamblea general para su
            conocimiento. <br />h) Expedir las cartas de “miembro del Colegio” a
            todos aquellos agremiados que estén al corriente de sus
            obligaciones. <br />i) Cuidar tanto la oportuna recaudación de
            ingresos, como que los compromisos del Colegio sean solventados
            oportunamente. <br />j) Formular los presupuestos anuales de
            ingresos y egresos, y administrarlos durante su gestión. <br />k)
            Proporcionar oportunamente a la junta de honor, las informaciones
            que requiera para el cumplimiento de sus funciones. <br />l) El
            pro-tesorero substituirá al tesorero en su ausencia temporal o
            definitiva, con todas las atribuciones y obligaciones que a este le
            corresponden.
          </p>

          <p>
            <strong>5.- Del Secretario propietario de Acción Gremial:</strong
            ><br />
            a) Proponer y coordinar los trabajos relativos a la promoción de la
            solidaridad y compañerismo de los Arquitectos colegiados, en las
            esferas profesional, social y familiar.
            <br />b) Integrar el directorio de Arquitectos colegiados por
            especialidades y localidad. <br />c) Integrar el directorio del
            servicio social profesional. <br />d) Vigilar el cumplimiento de los
            trabajos que anualmente desempeñen los miembros del Colegio, en el
            servicio social profesional. <br />e) Proponer y coordinar los
            trabajos relativos a la proyección del Colegio hacia la comunidad.
            <br />f) Difundir la labor profesional de los agremiados mediante la
            promoción de actividades y publicaciones periódicas.
          </p>

          <p>
            <strong>6.- Del Secretario de Superación Profesional:</strong><br />
            a) Promover permanentemente la capacitación y actualización
            profesional de los Arquitectos hacia los campos de acción que
            demanda la población de Tabasco.
            <br />b) Promover el intercambio de conocimientos con otras
            disciplinas relacionadas con la práctica de la Arquitectura.
            <br />c) Dar seguimiento y establecer controles sobre los resultados
            de los acuerdos y/o convenios establecidos con las universidades y
            centros de educación superior, así como realizar un informe a la
            asamblea sobre los mismos. <br />d) Vigilar la participación de los
            agremiados, en los programas de actualización continua que se
            realicen en el Colegio.
          </p>

          <p>
            <strong>7.-Del Vocal de Acción Urbana:</strong><br />
            De acuerdo al programa de trabajo establecido por el Consejo
            Directivo deberá:<br />
            a) Promover la participación activa de los Arquitectos en la mejor
            solución de los problemas urbanos, de medio ambiente y patrimonio
            arquitectónico, coordinándose para ello con las autoridades
            municipales, estatales y federales.
            <br />b) Proponer y participar activamente en la creación y
            mantenimiento de los órganos consultivos de desarrollo urbano y
            ecología de las autoridades municipales, estatales o federales en
            concordancia con las Leyes vigentes en la materia de desarrollo
            urbano y medio ambiente. <br />c) Participar activamente en el
            análisis, evaluación y propuesta de reforma de los reglamentos y
            Leyes relacionados con la profesión y práctica de la Arquitectura y
            su campo profesional a través de los conductos legales que para tal
            efecto tengan las autoridades municipales, estatales y federales,
            así como órganos legislativos y judiciales. <br />d) Rendir un
            informe del resultado de sus gestiones, en un periodo no mayor a un
            mes.
          </p>

          <h2>Capítulo 8.</h2>
          <p>
            <strong>Articulo cuadragésimo.-</strong> Los miembros del Colegio,
            al corriente de sus obligaciones, serán los únicos que tendrán
            derecho a ser electos para los puestos del Consejo Directivo,
            habiendo cumplido con los requisitos establecidos en el artículo
            trigésimo octavo de estos estatutos.
          </p>

          <p>
            <strong>Artículo cuadragésimo primero.-</strong> El Presidente, el
            Vicepresidente, el Secretario General y el Tesorero del Consejo
            Directivo serán electos por mayoría de votos de los miembros del
            padrón electoral mediante voto individual escrito y secreto, que al
            efecto se emita en los términos de los artículos trigésimos y
            cuadragésimo cuarto.
          </p>

          <p>
            Para que se considere válida la elección se requiere el voto de por
            lo menos del cincuenta por ciento más uno de los miembros del padrón
            electoral formado como se indica en el artículo trigésimo, si no
            hubiese quórum en la primera convocatoria se hará una segunda,
            catorce días después, siguiendo el mismo procedimiento de la
            primera.
          </p>

          <p>
            <strong>Artículo cuadragésimo segundo.-</strong> Para efectos de
            elecciones del El Presidente, el Vicepresidente, el Secretario
            General y el Tesorero del Consejo Directivo, el voto de todos los
            miembros del padrón electoral será de igual valor y calidad.
          </p>

          <p>
            <strong>Articulo cuadragésimo tercero.-</strong> La convocatoria
            para elecciones será lanzada por la comisión electoral, esta
            comisión estará integrada por el Presidente de la junta de honor y
            dos miembros más de dicha junta por ella designados; la comisión
            será presidida por el Presidente de la junta de honor, y en su
            ausencia por un miembro de la misma que el mismo designe, y se
            instalará en la última asamblea del año non, que se celebrará en el
            mes de diciembre.
          </p>

          <p>
            <strong>Artículo cuadragésimo cuarto.-</strong> El Presidente de la
            comisión electoral tendrá a su cargo la elaboración del padrón
            electoral que estará constituido con: <br />a) Nombre. <br />b)
            Número de miembro. <br />c) Número consecutivo. <br />d) Domicilio.
            <br />e) Teléfono. <br />f) Correo electrónico. <br />g) Numero de
            asistencia a asambleas. <br />h) Constancia de no adeudo, debiendo
            haber cubierto, tanto las cuotas ordinarias como las extraordinarias
            y aranceles de DRO.
          </p>

          <p>
            El padrón electoral quedará cerrado el día treinta y uno de
            diciembre de los años impares, toda la información que requiera la
            comisión electoral será facilitada y avalada por el Consejo
            Directivo en funciones quienes deberán tener la documentación
            comprobatoria a disposición.
          </p>
          <p>
            Para ser integrante del padrón electoral, los miembros de número
            deberán cumplir con una antigüedad mínima de dos años al cierre del
            mismo.
          </p>

          <p>
            El padrón electoral deberá quedar validado por la comisión electoral
            el día 15 de enero de los años pares y será publicado a la vista en
            el interior del colegio para su consulta y será entregado en
            protocolo oficial a los candidatos que hayan sido debidamente
            registrados por la comisión electoral.
          </p>

          <p>
            La información del padrón electoral será para uso exclusivo del
            proceso electoral, por lo que el manejo y buen uso de esta será
            responsabilidad del Consejo Directivo en funciones y de los
            candidatos que lo hayan recibido, en caso de comprobarse un uso
            indebido podrá considerarse el hecho como un causal de
            descalificación del candidato o destitución de miembro del Consejo
            que tenga responsabilidad al respecto.
          </p>

          <p>
            Los expresidentes serán considerados miembros permanentes del padrón
            electoral.
          </p>

          <p>
            <strong>Artículo cuadragésimo quinto.-</strong> La convocatoria para
            las elecciones será lanzada por la comisión electoral el día quince
            de Enero de los años pares. El plazo para el registro de la planilla
            queda comprendido de la fecha anterior al primer sábado de Febrero
            que cierre la primera semana completa de ese mes a las doce horas.
          </p>

          <p>
            <strong>Artículo cuadragésimo sexto.-</strong> Una vez publicada la
            convocatoria quedara abierto el registro de planilla. Para obtener
            el registro, los interesados deberán presentar a la comisión
            electoral, documentos con los cuales comprueben que la apoyan en su
            candidatura cuando menos el 20 % de los miembros del padrón
            electoral, debiendo tales documentos estar debidamente fechados y
            firmados.
          </p>

          <p>
            El apoyo podrá ser otorgado por los miembros del padrón electoral, a
            uno o más candidatos.
          </p>

          <p>
            Como requisito para integrar la Planilla, ninguno de sus miembros
            deberá ostentar cargos públicos, ni dentro del consejo directivo en
            funciones, por lo que deberán renunciar a su cargo a más tardar un
            día antes de la última asamblea del año impar.
          </p>

          <p>
            <strong>Articulo cuadragésimo séptimo.-</strong> Una vez concluido
            el plazo fijado para el registro de planillas, la comisión
            electoral, dará a conocer en el domicilio social del Colegio, la
            lista de planillas aprobadas que podrán participar en el proceso
            electoral.
          </p>

          <p>
            En caso de registro declarado desierto, ya sea por falta de
            planillas inscritas o por incumplimiento de requisitos, la comisión
            electoral convocará a nuevas elecciones a realizarse en un plazo no
            mayor de 30 días, y establecerá los procedimientos a seguir, lo
            anterior sin modificar el período de ejercicio establecido en estos
            estatutos.
          </p>

          <p>
            <strong>Artículo cuadragésimo octavo.-</strong> La elección será el
            último lunes del mes de Febrero de los años pares iniciando el
            proceso de votación a partir de las 19:00 hrs. donde la comisión
            electoral repartirá las boletas de votación mismas que contendrán
            los nombres de las planillas a elegir. Las boletas se entregarán
            únicamente a los colegiados que estén registrados en el padrón
            electoral debiendo firmar acuse de recibo de la misma.
          </p>

          <p>
            Los colegiados deberán de cruzar en la boleta la planilla elegida y
            depositarla en la urna instalada para tal efecto. A las 21:00 hrs.
            se dará por concluida las votaciones y la comisión electoral
            procederá al conteo de votos de manera directa y en presencia de la
            asamblea debiendo coincidir estos con las boletas entregadas del
            padrón electoral.
          </p>

          <p>
            Cada planilla nombrara un representante para la verificación de las
            boletas, la urna, el padrón electoral y la votación.
          </p>

          <p>
            Una vez instalada la asamblea de elecciones, se procederá a la
            votación que se efectuará mediante un voto personalizado y secreto,
            depositado en una urna que para tal efecto se habrá instalado y
            revisado tanto por la comisión electoral, los escrutadores y los
            representantes de los candidatos acreditados para tal efecto.
          </p>

          <p>
            La asamblea contará con la presencia de un notario público que dará
            fe de los hechos, se deberá de invitar a la dirección de profesiones
            de la Secretaria de Educación Pública, como testigo de honor.
          </p>

          <p>
            A las 21:00 hrs. se dará por concluida las votaciones y la comisión
            electoral procederá al conteo de votos de manera directa y en
            presencia de la asamblea debiendo coincidir estos con las boletas
            entregadas del padrón electoral.
          </p>

          <p>
            <strong>Articulo cuadragésimo noveno.-</strong> Una vez que la
            comisión electoral a concluido el computo de los votos, deberá
            comunicar por escrito a la planilla electa, que a partir de este
            momento pasara a ser Presidente, Vicepresidente, Secretario General
            y Tesorero electos, a los cuales se le debe tomar la protesta como
            tal en este acto.
          </p>

          <p>
            <strong>Articulo quincuagésimo.-</strong> En caso de registro de
            planilla única, esta se someterá a votación y para ser electa deberá
            cumplir con el 50% más uno de los votos de los miembros que
            conforman el padrón electoral. En caso de no obtener el número de
            votos requeridos, deberá convocarse a nuevas elecciones, en los
            términos descritos en el artículo cuadragésimo primero.
          </p>

          <p>
            En el caso de que en las elecciones se inscriban más de dos
            planillas, para que alguna resulte ganadora deberá de igual manera
            cumplir con el porcentaje arriba mencionado, de no ser así, se
            convocara a una segunda vuelta en los términos arriba descritos,
            donde solo participaran las dos planillas que hayan obtenido el
            mayor número de votos en la primera elección.
          </p>

          <p>
            Los miembros de la comisión electoral que se encuentran en la mesa
            de votación, podrán solicitar identificación con fotografía para
            identificar el votante.
          </p>

          <p>
            El día de la asamblea de elecciones, no se podrá hacer propaganda
            electoral alguna ni promover de manera directa o indirecta a alguna
            planilla, ni dentro de las instalaciones del CAT ni en el perímetro
            de las mismas.
          </p>

          <p>
            <strong>Articulo quincuagésimo primero.-</strong> La planilla electa
            con su consejo directivo debidamente integrado, se reunirá a más
            tardar catorce días después de la elección, a las veinte horas para
            la toma de protesta protocolaria y entrega recepción bajo protesta
            de ley, concretándose de esta manera la transferencia de
            responsabilidades, la sesión será presidida por el Presidente de la
            comisión electoral o por la persona que este designe quien deberá
            ser también miembro de esta comisión, la junta de honor y justicia,
            así como al presidente del consejo consultivo.
          </p>

          <p>
            <strong>Artículo quincuagésimo segundo.-</strong> En caso de
            renuncia del Presidente y del Vicepresidente, el secretario asumirá
            el interinato para solicitar la integración de la comisión
            electoral, misma que convocará a elecciones en los términos
            establecidos en el artículo cuadragésimo primero.
          </p>

          <h2>Capítulo 9. De las modificaciones de estatutos y reglamentos</h2>

          <p>
            <strong>Artículo quincuagésimo tercero.-</strong> Las solicitudes
            para modificaciones a estatutos y reglamento interno pueden ser
            presentadas por uno o varios de los miembros del Colegio que estén
            al corriente de sus obligaciones, ante la Junta de Honor y Justicia,
            la cual turnará dicha solicitud, a la comisión revisora de estatutos
            para su análisis y dictamen correspondiente.
          </p>

          <p>
            <strong>Artículo quincuagésimo cuarto.-</strong> Los estatutos
            podrán ser modificados en sesión extraordinaria de asamblea en la
            que estén presentes cuando menos el 75% de total de miembros al
            corriente de sus obligaciones, de conformidad con el artículo
            trigésimo de estos estatutos. Para que sea válida la modificación de
            los estatutos, se deberá contar con el 75% de votos aprobatorios.
          </p>

          <p>
            <strong>Articulo quincuagésimo quinto.-</strong> El Consejo
            Directivo y la junta de honor podrán proponer a la asamblea general,
            las modificaciones a los estatutos y reglamentos que juzguen
            convenientes. La asamblea pedirá a la comisión revisora de estatutos
            y reglamentos su participación, la cual estará constituida por
            cuatro de los miembros del Consejo Directivo, el Presidente y tres
            consejeros de la junta de honor.
          </p>

          <p>
            <strong>Articulo quincuagésimo sexto.-</strong> La comisión revisora
            de estatutos y reglamentos estará presidida por el Presidente de la
            junta de honor quien tendrá voto de calidad en caso de empate. La
            comisión tendrá un periodo de gestiones idéntico al del Consejo
            Directivo y la junta de honor, y su renovación se hará 30 días
            después de la toma de posesión del consejo y la junta de honor.
          </p>

          <h2>Capítulo 10. De las comisiones de trabajo</h2>

          <p>
            <strong>Artículo quincuagésimo séptimo.-</strong> A juicio del
            Consejo Directivo podrán crearse tantas comisiones de trabajo como
            sean necesarias para el desarrollo de las labores del Colegio. Su
            duración podrá ser permanente o temporal, de acuerdo con su
            naturaleza.
          </p>

          <p>
            <strong>Articulo quincuagésimo octavo.-</strong> El Consejo
            Directivo, revisará los programas que formulen dichas comisiones y
            los informes sobre el desarrollo de sus labores, que presentaran por
            lo menos una vez cada quince días regularmente y ocho días antes de
            la fecha fijada para las asambleas ordinarias o extraordinarias que
            se convoquen.
          </p>

          <p>
            <strong>Articulo quincuagésimo noveno.-</strong> Los puestos
            desempeñados por los miembros del Colegio en las comisiones en que
            hayan sido convocados, serán honoríficos, pero serán considerados en
            el cómputo del servicio social profesional.
          </p>

          <h2>Capítulo 11. De los directores responsables de obra</h2>

          <p>
            <strong>Artículo sexagésimo.-</strong> Todos los miembros de número
            que estén al corriente de sus obligaciones gremiales, tendrán
            derecho a ser propuestos como directores responsables de obra y/o
            corresponsables en diseño arquitectónico y urbano, conforme a lo
            establecido en la normatividad vigente.
          </p>

          <h2>Capítulo 12. Del servicio social profesional</h2>

          <p>
            <strong>Artículo sexagésimo primero.-</strong> El servicio social
            profesional deberá ser presentado por los miembros del Colegio en
            los términos que marca la Ley Reglamentaria de los Artículos 4º y 5º
            de la Constitución Federal relativa al Ejercicio de las Profesiones
            en el Estado de Tabasco.
          </p>

          <p>
            <strong>Artículo sexagésimo segundo.-</strong> Se considera forma de
            presentación del servicio social profesional por parte de los
            miembros del Colegio, para efectos de coordinación y registro, las
            siguientes: <br />a) Las labores realizadas voluntaria y
            personalmente en las comisiones de trabajo adscritas a las
            secretarias de acción ejecutiva, a nivel Colegio. <br />b) Las
            labores realizadas voluntaria y personalmente en los órganos
            administrativos y de gobierno tanto del Colegio como de la
            Federación de Colegios de Arquitectos de la República Mexicana A.C.
            <br />c) Las comisiones desempeñadas voluntaria y personalmente en
            los órganos de consulta convocados por la autoridad municipal,
            estatal o federal no remuneradas. <br />d) La comisión revisora de
            estatutos y reglamentos del Colegio, expedirá el reglamento del
            servicio social profesional, indicando la forma en que deberán
            coordinarse, evaluarse y registrarse las acciones que impliquen la
            presentación del mencionado servicio en el ámbito municipal, así
            como los reconocimientos a quienes hayan destacado en este
            cumplimiento; y la forma y periodicidad con la que deberán
            comunicarse a la dirección General de Profesiones, el cumplimiento
            del servicio social profesional por parte de la membrecía.
          </p>

          <h2>Capítulo 13. De las sanciones</h2>

          <p>
            <strong>Articulo sexagésimo tercero.-</strong> Conforme a lo
            dispuesto por los incisos “p” y “q” del Articulo cuarenta y siete de
            la Ley Reglamentaria de los Artículos 4º y 5º de la Constitución
            Federal relativa al Ejercicio de las Profesiones en el Estado de
            Tabasco, el Colegio podrá aplicar sanciones a sus miembros que se
            hayan hecho acreedores a ellas desde una amonestación hasta la
            expulsión de su seno.
          </p>

          <p>
            <strong>Artículo sexagésimo cuarto.-</strong> Para la aplicación de
            sanciones la junta de honor deberá sujetarse al siguiente
            procedimiento:

            <br />a) Investigación del caso. <br />b) Información del miembro
            sujeto a investigación, de los resultados de ésta. <br />c) Práctica
            de la defensa del miembro investigado. <br />d) Deliberación de la
            Junta de Honor y Justicia. <br />e) Resolución de la Junta de Honor
            y Justicia.
          </p>

          <p>
            <strong>Articulo sexagésimo quinto.-</strong> Si el Arquitecto
            investigado fuese absuelto por la junta de honor, tal absolución se
            hará pública o se mantendrá secreta a elección del Arquitecto
            absuelto.
          </p>

          <p>
            <strong>Articulo sexagésimo sexto.-</strong> El procedimiento
            señalado en el artículo (sexagésimo cuarto) deberá ser secreto hasta
            en tanto la junta de honor resuelva que el investigado es acreedor a
            una sanción.
          </p>

          <h2>Capítulo 14. De los premios y reconocimientos</h2>

          <strong>Articulo sexagésimo séptimo.-</strong> Conforme a lo dispuesto
          en el artículo sexto de estos estatutos y con el afán de enaltecer el
          quehacer de los Arquitectos, y compendiar la obra arquitectónica
          estatal, nacional e internacional, así como reconocer al Arquitecto
          por sí mismo en el desarrollo de su vida profesional y la excelencia
          que la sociedad y la nación demandan, se establecen la asignación de
          tres premios; cuya entrega deberá ajustarse a los términos que se
          indiquen a continuación:

          <p>
            1.- En los años nones, se efectuará la “Bienal de Arquitectura
            Tabasqueña”, misma que será convocada en el mes de agosto y se
            premiara en el mes de octubre, premio que consiste en recibir
            reconocimiento alusivo, cuyos objetivos son:
            <br />a) Reconocer y difundir la obra arquitectónica relevante que
            se está realizando en nuestro estado así, como sus autores. <br />b)
            Identificar las obras destacadas de los Arquitectos colegiados en
            todo el estado, para darlas a conocer al gremio mismo, a la crítica,
            a las autoridades, promotores y público en general. <br />c) Mostrar
            la obra arquitectónica destacada como medio para analizar, discutir
            y reflexionar acerca de la Arquitectura en Tabasco.
          </p>
          <p>
            2.- En los años pares se establece el “Reconocimiento Bienal Arq.
            Víctor Manuel Pastrana Mondragón”, premio que consiste en recibir la
            medalla Arq. Víctor Manuel Pastrana Mondragón, misma que será
            convocada en el mes de agosto y se premiara en el mes de octubre,
            cuyos objetivos son:

            <br />a) Reconocer a aquellos Arquitectos que se hayan distinguido
            en el desarrollo de su compromiso profesional, habiendo manifestado
            su esfuerzo en beneficio de Tabasco y el País con un reconocido
            desempeño gremial. <br />b) El jurado para otorgar dicho premio,
            será integrado en la asamblea ordinaria previa a la fecha de entrega
            del mismo, se conformará por tres miembros del consejo directivo,
            dos miembros del consejo consultivo, y dos miembros electos por la
            asamblea y será presidido por uno de sus miembros electos por sus
            integrantes.
          </p>
          <p>
            3.- Cuando a juicio del Consejo Directivo y aprobado por la
            asamblea, se considere tener los méritos necesarios, se otorgará el
            premio “Calli Olmeca”, que consiste en recibir estatuilla alusiva,
            para:

            <br />c) Reconocer al Arquitecto sea colegiado o no, por la
            trascendencia y aporte de su obra arquitectónica ya sea estatal,
            nacional o internacional. Reconocer la labor en beneficio del gremio
            de los expresidentes del Colegio al concluir su encargo.
          </p>

          <h2>Capítulo 15. De la disolución del colegio</h2>

          <p>
            <strong>Artículo sexagésimo octavo.-</strong> El Colegio de
            Arquitectos Tabasqueños A.C. se disolverá:

            <br />a) Por encontrarse en un caso expresamente previsto por las
            Leyes que regulan las Asociaciones Civiles.

            <br />b) Por resolución fundada e inapelable de la autoridad
            competente.

            <br />c) Por acuerdo de asamblea general y por lo menos el 75% de
            los miembros.
          </p>

          <p>
            <strong>Artículo sexagésimo noveno.-</strong> Acordada la disolución
            se procederá a la liquidación, la cual será practicada por dos
            liquidadores que designe la asamblea general en el mismo auto, o por
            quienes designe la dirección de profesiones, de acuerdo con lo
            establecido por la Ley Reglamentaria del artículo 5 constitucional.
            Los liquidadores tendrán la representación legal del Colegio para
            los efectos de la liquidación.
          </p>

          <p>
            <strong>Artículo septuagésimo.-</strong> Pagados todos los adeudos,
            los bienes del Colegio y el saldo que resulte, se aplicara a
            beneficio de las instituciones que designe la dirección General de
            Profesiones.
          </p>

          <h3>Artículos transitorios</h3>

          <p>
            <strong>Primero.-</strong> Los presentes estatutos entraran en vigor
            desde la fecha de su aprobación.
          </p>

          <p>
            <strong>Segundo.-</strong> Los presentes estatutos deberán ser
            protocolizados debidamente e inscritos en el registro público de la
            propiedad y del comercio.
          </p>

          <p>
            <strong>Tercero.-</strong> El concepto acreditable mencionado en el
            artículo Trigésimo Octavo, entrara en vigor a partir de 6 meses de
            la aprobación de los presentes estatutos.
          </p>

          <p>
            <strong>Cuarto.-</strong> Los presentes estatutos fueron aprobados
            por la asamblea extraordinaria celebrada en la ciudad de
            Villahermosa, Estado de Tabasco el día 27 de noviembre de 2017
            contándose con la presencia de los siguientes colegiados:
          </p>

          <p>
            08 Arq. Juan Antonio Medina Palomera<br />
            14. Arq. Rubén Luis Susunaga López<br />
            22. Arq. Eduardo Víctor Gallegos Shaul<br />
            31. Arq. Víctor Manuel Acevedo Gil<br />
            36. Arq. Lorenzo de Jesús Rodas Cantón<br />
            42. Arq. Agustín Centurión Hidalgo<br />
            46. Arq. Jorge Alejandro Ibarra Vergara<br />
            49. Arq. Jorge Antonio León Rasgado<br />
            51. Arq. Miguel Ángel Guzmán Alejandro<br />
            53. Arq. Andrés Juan Gómez Cano<br />
            54. Arq. Julia Alicia Moreno Farías<br />
            60. Arq. Rafael Jesús Herrera Olvera<br />
            65. Arq. Ricardo Díaz Leal Aldana<br />
            74. Arq. José Luis Díaz del Castillo Trujillo<br />
            76. Arq. Guillermo Ortiz Maldonado<br />
            77. Arq. Gilberto Donaciano Vázquez Sánchez<br />
            78. Arq. Jorge Pérez Castillo<br />
            84. Arq. Carlos Enrique Muñoz Manzur<br />
            86. Arq. Carlos Arturo Aguilar Polanco<br />
            90. Arq. Ernesto Alonso Jesús Pereyra<br />
            91. Arq. Julián Manzur Pérez<br />
            92. Arq. Jorge Francisco Navarro López<br />
            98. Arq. Armando Javier Reyna Díaz del Castillo<br />
            100. Arq. Héctor Daniel Pastrana Falcón<br />
            101. Arq. Jorge Armando González Valencia<br />
            109. Arq. Jesús Tapia Mayans<br />
            110. Arq. Perla del Rocío González Llergo<br />
            126. Arq. Mario Alberto Cámara Domínguez<br />
            132. Arq. Francisco Javier Espinosa Gallegos<br />
            133. Arq. Samuel Priego Hernández<br />
            141. Arq. Manuel Mario Martínez Arango<br />
            143. Arq. Jorge Alberto Cámara Domínguez<br />
            148. Arq. Daniel Capetillo Vidal<br />
            149. Arq. Rogelio Ramírez Falconi<br />
            151. Arq. Alejandra Sánchez Prats<br />
            152. Arq. Vanessa Matus Ocaña<br />
            155. Arq. Adolfo Méndez López<br />
            171. Arq. Miguel Ramsés Vázquez Ortiz<br />
            178. Arq. Sonia Isabel Carrillo Salazar<br />
            180. Arq. Tito Wilber Olán Morales<br />
            182. Arq. Alejandro Mayo González<br />
            188. Arq. Pablo Ulises Jiménez López<br />
            197. Arq. Jorge Enrique Tadeo Bejarano Correa<br />
            202. Arq. Rodolfo Martín Bustamante Sandoval<br />
            203. Arq. Robín Manuel Reyes Suárez<br />
            205. Arq. Flor de María Flor Pool García<br />
            208. Arq. Guadalupe Hernández Domínguez<br />
            209. Arq. Carlos Mario Brindis Mollinedo<br />
            212. Arq. Jesús Salvatierra Camacho<br />
            216. Arq. Víctor Manuel Cervantes Calcáneo<br />
            217. Arq. Javier Arturo Argüello Martínez<br />
            222. Arq. Felipe Ocampo Montejo<br />
            223. Arq. Cuauhtémoc Parra Bautista<br />
            228. Arq. Ernesto Alonso Lozano Cruz<br />
            231. Arq. Sergio Rueda Pérez<br />
            234. Arq. Luis Javier Cid Moscoso<br />
            240. Arq. Eduardo Rueda Pérez<br />
            241. Arq. Agustín Gustavo Rodríguez López<br />
            242. Arq. Porfirio Díaz Vázquez<br />
            244. Arq. Arturo Esparza Rodríguez<br />
            248. Arq. Eloise Carla Boj Pralón<br />
            259. Arq. Yolanda del Carmen Castro Suárez<br />
            261. Arq. Eduardo Vázquez Cruz<br />
            263. Arq. Ricardo Gómez Rodríguez<br />
            266. Arq. Arianna Rodríguez Manzur<br />
            270. Arq. Fátima Cristal del Socorro López Zentella<br />
            273. Arq. Juan Pablo Candelaria Ledesma<br />
            276. Arq. Francisco Tereso Ramírez Torija<br />
            280. Arq. José Luis Pérez Angulo<br />
            286. Arq. Pedro Luis Alvarado de la Cruz<br />
            290. Arq. Luis Antonio Álvarez Morales<br />
            292. Arq. José Rafael Torres García<br />
            293. Arq. Lidia Alejandra Guzmán Balboa<br />
            294. Arq. Andrés Antonio Brito Morales<br />
            297. Arq. Saúl Horacio Rodríguez de la Cerda<br />
            298. Arq. Emeri Anahí Cachón Reyes<br />
            300. Arq. Flor de María Cruz Escobar<br />
            305. Arq. Ingrid Broca Ramírez<br />
            307. Arq. Doris del Carmen Iglesias Ramón<br />
            310. Arq. Guillermo Alexander Gutiérrez Cob<br />
            317. Arq. Dalina Almeida González<br />
            323. Arq. Georgina Natalia Olán Domínguez<br />
            325. Arq. Leydi Rubí Calva Doporto<br />
            326. Arq. Manuel Correa Sierra<br />
            327. Arq. Violeta Escobar Ruíz<br />
            328. Arq. Juan Carlos León Vázquez<br />
            343. Arq. Mario Norberto Madera Pérez<br />
            347. Arq. Fabián Coutiño Mendoza<br />
            348. Arq. Alicia Ponce Pérez<br />
            349. Arq. Elvira del Carmen Domínguez Arjona<br />
            350. Arq. Miguel Ángel Villanueva Serrano<br />
            354. Arq. Juan Miguel Olivares Ariño<br />
            358. Arq. Cynthia Giselle Hernández Pérez<br />
            361. Arq. Marcela del Carmen García Lanestosa<br />
            364. Arq. Wilivaldo Álvarez del Valle<br />
            377. Arq. José Natividad Marín Turriza<br />
            383. Arq. Cindy Cristel Cupil García<br />
            384. Arq. Erick García Romero<br />
            394. Arq. Jordán Miguel Martínez Alonso<br />
            395. Arq. Ángel Atilano Coello Lara.
          </p>
        </div>
      </div>
      <!-- Contenido starts -->
    </div>
    <div class="col-md-2 col-0"></div>
  </div>
</section>
